import React from 'react';

import { ResumeContentContext } from '../../types';
import { DEFAULT_CONTENT } from '../constants';
import { createProcessingTeamSummary, getLocationPreposition } from '../helpers';
import * as helpers from './helpers';

export const renderNotLoggedInContent = (context: ResumeContentContext): React.ReactNode => {
  const { steps, flags, borrowerData, ownerships, hasInvestmentAddress } = context;
  const { isBrokerMode = false, oneLine = false, hideLastStep, firstPerson = false, isBrokerResume = false, isProcessingTeamMode = false } = flags;
  const ownershipItems = Array.isArray(ownerships) ? ownerships : [];
  const hasOwnerships = ownershipItems.length > 0;
  const locationPreposition = getLocationPreposition(hasInvestmentAddress);

  if (!steps.state.isSet) {
    return DEFAULT_CONTENT;
  }

  // Solo state
  let content: React.ReactNode = helpers.renderStateOnly(steps, isBrokerMode, locationPreposition);

  if (!steps.loanType.isSet) {
    return content;
  }

  // State + loanType
  content = helpers.renderStateAndLoanType(steps, isBrokerMode, locationPreposition);

  if (!steps.loanOwner.isSet) {
    return content;
  }

  // State + loanType + loanOwner
  content = helpers.renderStateLoanTypeAndOwner(steps, isBrokerMode, locationPreposition);

  if (!steps.propertyType.isSet) {
    return content;
  }

  // State + loanType + loanOwner + propertyType
  content = helpers.renderWithPropertyType(steps, locationPreposition);

  if (!steps.ficoRange.isSet) {
    return content;
  }

  // Con FICO score
  if (!isBrokerMode) {
    content = helpers.renderWithFicoNonBroker(steps, oneLine, locationPreposition);
  } else {
    content = helpers.renderWithFicoBroker(steps, oneLine, locationPreposition);
  }

  if (!steps.propertiesNegotiated.isSet || hideLastStep) {
    return content;
  }

  // Contenido completo
  if (!oneLine) {
    if (!isBrokerMode && borrowerData) {
      content = helpers.renderCompleteWithBorrowerData(steps, ownershipItems, hasOwnerships, locationPreposition);
    } else if (!isBrokerMode) {
      content = helpers.renderCompleteWithoutBorrowerData(steps, locationPreposition);
    }

    if (isProcessingTeamMode) {
      return createProcessingTeamSummary(context, locationPreposition);
    }

    return content;
  }

  // Contenido en una línea
  if (isBrokerMode) {
    content = helpers.renderOneLineBroker(steps, isBrokerResume, locationPreposition);
  } else if (firstPerson) {
    content = helpers.renderOneLineFirstPerson(steps, locationPreposition);
  } else {
    content = helpers.renderOneLineNormal(steps, locationPreposition);
  }

  if (isProcessingTeamMode) {
    return createProcessingTeamSummary(context, 'at');
  }

  return content;
};

